export default __webpack_public_path__ + "static/media/headshot-square.d5bd35d9.jpg";